import * as React from 'react';
import { Flex, Text } from '@amzn/storm-ui';
import { AccountLabel } from './AccountLabel';
import { RetailerName } from './IA2AdvertisingAccountItem';

type IA2MobileAccountListItemProps = {
  accountLabel: string;
  countryLabel: string;
  retailerName?: string;
};

export const IA2MobileAccountListItem: React.FC<
  IA2MobileAccountListItemProps
> = ({ accountLabel, countryLabel, retailerName }) => {
  return (
    <Flex justifyContent="space-between">
      <Flex direction="column">
        <AccountLabel label={accountLabel} />
        {retailerName && (
          <RetailerName size="xsmall">{retailerName}</RetailerName>
        )}
        <Text color="tertiary">{countryLabel}</Text>
      </Flex>
    </Flex>
  );
};
